export const INITIALIZE_SIGN_UP = 'initialize-sign-up';

const initializeSignUp = () => (
  { type: INITIALIZE_SIGN_UP }
);
export default initializeSignUp;
